
//展会官网主域名
let baseUrl = window.location.host.includes('gw') || window.location.host.includes('localhost') ? 'http://gw.demo365.cc:18086' : "https://www.chinaminexpo.com";
let onlineUrl = window.location.host.includes('gw') || window.location.host.includes('localhost') ? 'http://gw.demo365.cc:18087' : "https://e-show.chinaminexpo.com";
let xianUrl = (window.location.host.includes('gw') || window.location.host.includes('localhost')) ? "http://gw.demo365.cc:18081" : "https://www.xianminexpo.com";
const zh_registered = 'https://dwz.cn/1GzY72r9'
const en_registered = "https://dwz.cn/TIBsKnr2"

const searchParams = new URLSearchParams(window.location.hash.split('?')[1])

export default {
    'fontUrl': baseUrl,   //图片公共路径
    "baseUploadUrl": baseUrl + "/frontCommon/upload",
    "hzExhibitionLogin": onlineUrl + "/exhibitor/#/adminLogin",
    "hzAudienceLogin": onlineUrl + "/visitor/#/adminLogin",
    "hzExhibitionIndex": onlineUrl + "/exhibitor/#/backIndex/homeIndex",
    "hzAudienceIndex": onlineUrl + "/visitor/#/backIndex/homeIndex",
    //跳转西安
    "xianzhanhui": xianUrl + "/hz/f",
    "xianviewcz": xianUrl + "/hz/f/list.html?categoryId=8ff76b57a6674525a898d5ba4026352c",
    "xianviewcg": xianUrl + "/hz/f/list.html?categoryId=423d542b5b2343f1ac216b425aa7ae33",
    "xianzwt": xianUrl + "/hz/f/hz/gzZwtIndex.html?categoryId=6f595480c4c74329bae5448ddf19cb8a",
    "xianzhrc": xianUrl + "/hz/f/list.html?categoryId=70b5d6c9d45245a09e51eff9b334e3c6",

    //三方预注册（官网快捷链接）
    'registered': !searchParams.get('lang') || searchParams.get('lang') == 'zh_CN' ? zh_registered : en_registered,


    "hzzhanhui": baseUrl + "/hz/f",
    "viewcz": baseUrl + "/hz/f/list.html?categoryId=8ff76b57a6674525a898d5ba4026352c",
    "viewcg": baseUrl + "/hz/f/list.html?categoryId=423d542b5b2343f1ac216b425aa7ae33",


    "zwt": baseUrl + "/hz/f/hz/gzZwtIndex.html?categoryId=6f595480c4c74329bae5448ddf19cb8a",
    "zhrc": baseUrl + "/hz/f/list.html?categoryId=70b5d6c9d45245a09e51eff9b334e3c6",
    "messageUrl": onlineUrl + "/visitor/#/backIndex/messageDetail",
    "axiosBaseUrl": baseUrl + '/hz/',

    "visit": baseUrl + '/hz/f/list.html?categoryId=423d542b5b2343f1ac216b425aa7ae33', //我要参观
    "ParticipateExhibition": baseUrl + '/hz/f/list.html?categoryId=8ff76b57a6674525a898d5ba4026352c', //我要参展

    "testDomain": 'http://vr.chinaminexpo.com/'
}
